import React from 'react';
import { CloudArrowUp } from '@phosphor-icons/react';
import { Upload } from 'antd';
import type { UploadFile } from 'antd/es/upload/interface';
import { isMobile, isTablet } from 'react-device-detect';

interface Props {
  type: 'people' | 'hl-reel' | 'clips';
  uploadRef: React.MutableRefObject<null>;
  beforeUpload: (file: UploadFile, files: UploadFile[]) => void;
  isSample?: boolean;
}

const AssetsUpload: React.FC<Props> = (props) => {
  const { type, uploadRef, beforeUpload, isSample } = props;

  let draggerProps: {} = { name: 'file', showUploadList: false };

  if (type === 'people')
    draggerProps = {
      ...draggerProps,
      accept: '.bmp,.gif,.jpeg,.jpg,.png',
      multiple: true,
    };
  else if (type === 'hl-reel')
    draggerProps = {
      ...draggerProps,
      accept: '.mov,.mp4',
      maxCount: 1,
      multiple: false,
    };
  else if (type === 'clips')
    draggerProps = {
      ...draggerProps,
      accept: '.mov,.mp4',
      multiple: true,
    };

  const typeText: string = type === 'hl-reel' ? 'highlight reel' : type;

  return (
    <div className="flex flex-col gap-2">
      {isSample && (
        <div className="italic mt-2">
          You cannot upload your own files here, but you'll be able to in all
          live projects.
        </div>
      )}

      <Upload.Dragger
        {...draggerProps}
        className="w-full rounded-md shadow-xl transition-all hover:bg-grey-100"
        beforeUpload={(file, fileList) => beforeUpload(file, fileList)}
        ref={uploadRef}
        disabled={isSample}
      >
        <div className="flex flex-col items-center justify-center gap-2 px-4 py-8">
          <CloudArrowUp size="2.5rem" />

          {isMobile || isTablet ? (
            <div className="text-md">
              <b>Click here</b> to upload {typeText}
            </div>
          ) : (
            <div className="text-md">
              <b>Drag & drop</b> to upload {typeText}
              <br />
              or <b>click here to browse</b>
            </div>
          )}
        </div>
      </Upload.Dragger>
    </div>
  );
};

export default AssetsUpload;
